import {EventEmitter, Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {PaymentCreate} from '../models/payment.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
export interface PaymentResponseData {
    ssl_merchant_id: string;
    ssl_user_id: string;
    ssl_pin: string;
    ssl_transaction_type: string;
    ssl_test_mode:boolean;
    ssl_token: string;
    ssl_txn_auth_token: string;
    ssl_card_number:string;
    ssl_exp_date: string;
    ssl_get_token: string;
    ssl_add_token: string;
    ssl_first_name: string;
    ssl_last_name: string;
    ssl_cvv2cvc2: string;
    ssl_amount: string;
    ssl_merchant_txn_id: string;
}



@Injectable({providedIn: 'root'})
export class PaymentService {

    paymentProcessEmitter = new EventEmitter<number>();
    paymentChanged = new Subject<PaymentCreate>();

    isPaymentProcessed = new Subject<boolean>();
    isPaymentError = new Subject<boolean>();

    constructor(private http: HttpClient) {
    }
    setPaymentIPAddress() {

return this.http.get('https://api.ipify.org/?format=json');
        //return this.http.get('https://server.ozshuttle.com/api/extras/getip.php');
        //return this.http.get('https://api.ipify.org/?format=json');
      // return this.http.get('https://www.convergepay.com/hosted-payments/?format=json');
    }

}
